<template>
  <div>
    <button
      class=" btn btn-warning mt-2 mx-1"
      @click="performAction"
      :disabled="accountLoading"
    >
      <span v-if="accountLoading">Please wait...</span>
      <span v-else> Verify {{ identityName }} </span>
    </button>

    <modal v-show="showModal" @close="closeModal" footer modalIsLarge>
      <template v-slot:title>
        <h5>Information Details</h5>
      </template>
      <template v-slot:body>
        <div class=" card-content" v-if="bvnDetails">
          <div class="card-body">
            <ImageMagnifying :img="bvnDetails.captured_image" />
            <ImageMagnifying :img="bvnDetails.image" />
            <KeyValue objKey="First Name" :objValue="bvnDetails.first_name" />
            <KeyValue objKey="Last Name" :objValue="bvnDetails.last_name" />
            <KeyValue
              objKey="Other NAme"
              :objValue="bvnDetails.other_name"
              v-if="bvnDetails.other_name"
            />
            <KeyValue
              objKey="Middle Name"
              :objValue="bvnDetails.middle_name"
              v-if="bvnDetails.middle_name"
            />
            <KeyValue
              objKey="BVN"
              :objValue="bvnDetails.bvn"
              v-if="bvnDetails.bvn"
            />
            <KeyValue
              objKey="Address"
              :objValue="bvnDetails.address"
              v-if="bvnDetails.address"
            />
            <KeyValue
              objKey="DOB"
              :objValue="bvnDetails.dob"
              v-if="bvnDetails.dob"
            />
            <KeyValue
              objKey="Email"
              :objValue="bvnDetails.email"
              v-if="bvnDetails.email"
            />
            <KeyValue
              objKey="Enrollment Bank"
              :objValue="bvnDetails.enrollment_bank"
              v-if="bvnDetails.enrollment_bank"
            />
            <KeyValue
              objKey="Enrollment Branch"
              :objValue="bvnDetails.enrollment_branch"
              v-if="bvnDetails.enrollment_branch"
            />
            <KeyValue
              objKey="Account Level"
              :objValue="bvnDetails.level_of_account"
              v-if="bvnDetails.level_of_account"
            />
            <KeyValue objKey="First Mobile" :objValue="bvnDetails.mobile" />
            <KeyValue objKey="Second Mobile" :objValue="bvnDetails.mobile_2" />
            <KeyValue
              objKey="NIN"
              :objValue="bvnDetails.nin"
              v-if="bvnDetails.nin"
            />
            <KeyValue
              objKey="State Of Origin"
              :objValue="bvnDetails.state_of_origin"
            />
            <KeyValue
              objKey="State Of Residence"
              :objValue="bvnDetails.state_of_residence"
            />
          </div></div
      ></template>
      <template v-slot:footer>
        <button @click.prevent="closeModal" class=" btn btn-warning w-auto">
          Cancel
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import KeyValue from "@/components/KeyValue.vue";
import ImageMagnifying from "../components/ImageMagnifying.vue";
export default {
  name: "VerifyIdentity",
  components: {
    KeyValue,
    ImageMagnifying
  },
  props: {
    identifier: {
      type: String,
      default: ""
    },
    identityName: {
      type: String,
      default: ""
    },
    identityType: {
      type: String,
      default: ""
      // nin , phone, bvn
    }
  },
  data() {
    return {
      showModal: false,
      accountLoading: false,
      bvnDetails: null
    };
  },
  methods: {
    closeModal() {
      this.showModal = !this.showModal;
    },
    performAction() {
      if (this.identityType === "bvn") {
        this.viewBVN();
      }
      if (this.identityType === "nin") {
        this.viewNIN();
      }
      if (this.identityType === "phone") {
        this.viewPhone();
      }
    },
    async viewPhone() {
      this.accountLoading = true;
      try {
        const res = await ApiService.post("verification/verify_phone", {
          phone_number: this.identifier
        });
        // console.log(res);
        // console.log(res.data.data.image);
        this.bvnDetails = res.data.data;
        this.accountLoading = false;
        this.closeModal();
      } catch (error) {
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async viewNIN() {
      this.accountLoading = true;
      try {
        const res = await ApiService.post("verification/verify_nin", {
          nin: this.identifier
        });
        console.log(res);
        console.log(res.data.data.image);
        this.bvnDetails = res.data.data;
        this.accountLoading = false;
        this.closeModal();
      } catch (error) {
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async viewBVN() {
      this.accountLoading = true;
      try {
        const res = await ApiService.post("bvn/view", {
          bvn: this.identifier
        });
        console.log(res.data.data.image);
        this.bvnDetails = res.data.data;
        this.accountLoading = false;
        this.closeModal();
      } catch (error) {
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    }
  }
};
</script>

<style scoped></style>
